import { render, staticRenderFns } from "./pharamaday.vue?vue&type=template&id=64dc51dd&scoped=true&"
import script from "./pharamaday.vue?vue&type=script&lang=js&"
export * from "./pharamaday.vue?vue&type=script&lang=js&"
import style0 from "./pharamaday.vue?vue&type=style&index=0&id=64dc51dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc51dd",
  null
  
)

export default component.exports